import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { Accordion } from '@/components/enlayouts/Ir/Mpocket/Accordion'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const ProjectionPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Business Plan and Growth Potential"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Accordion
        id="irp-library-category"
        className="irp-library-category irp-library-category-4"
      />
    </Layout>
  )
}

ProjectionPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir/' },
    { name: 'IR Library', path: '/en/ir/library/' },
    { name: 'Business Plan and Growth Potential', path: '' },
  ]

  return (
    <>
      <Head
        title="Business Plan and Growth Potential"
        description="Our business model, strategies and measure to achieve medium- to long-term growth."
        ogp={{ url: 'en/ir/library/projection/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
